/**
 * @generated SignedSource<<d29f7690de2e6345a6b12960f0563587>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentLinkActivePixCreditCard_charge$data = {
  readonly value: number | null | undefined;
  readonly valueWithDiscount: number | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"useChargePaymentMethod_charge">;
  readonly " $fragmentType": "PaymentLinkActivePixCreditCard_charge";
};
export type PaymentLinkActivePixCreditCard_charge$key = {
  readonly " $data"?: PaymentLinkActivePixCreditCard_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentLinkActivePixCreditCard_charge">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "valueWithDiscount",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "method",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentLinkActivePixCreditCard_charge",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "kind": "InlineDataFragmentSpread",
      "name": "useChargePaymentMethod_charge",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "availablePaymentMethods",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "paymentMethods",
          "plural": true,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/),
                (v3/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "brCode",
                  "storageKey": null
                },
                (v0/*: any*/),
                (v1/*: any*/)
              ],
              "type": "PaymentMethodPix",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/)
              ],
              "type": "PaymentMethodInstallments",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/),
                (v3/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "installmentNumber",
                  "storageKey": null
                },
                (v0/*: any*/)
              ],
              "type": "PaymentMethodCreditCard",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/),
                (v3/*: any*/),
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "consentId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "authorizationUrl",
                  "storageKey": null
                }
              ],
              "type": "PaymentMethodITP",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/),
                (v3/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "boletoBarcode",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "boletoDigitable",
                  "storageKey": null
                },
                (v0/*: any*/)
              ],
              "type": "PaymentMethodBoleto",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "Charge",
  "abstractKey": null
};
})();

(node as any).hash = "f41dc0bf81a8ed7a55c87049caf23522";

export default node;
